import styled from 'styled-components';

export const StyledBatchInfosLocationsRow = styled.div``;

export const StyledActionsWrap = styled.div`
  display: flex;
  align-items: center;
`;
